/* global axios */
import ApiClient from './ApiClient';

class WiseCompaniesAPI extends ApiClient {
  constructor() {
    super('wise/companies', { accountScoped: true });
  }
}

export default new WiseCompaniesAPI();
